import React from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import logo_login from "../../assets/images/logo-login.png";
import logo_branca from "../../assets/images/logo-branca-footer.png";
import ic_whats from "../../assets/images/whatsapp.png";
import ic_telephone from "../../assets/images/telephone.png";
import ic_mail from "../../assets/images/mail.png";

import ic_insta_white from "../../assets/images/icons/ic_insta_white.png";
import ic_face_white from "../../assets/images/icons/ic_face_white.png";
import ic_linkedin_white from "../../assets/images/icons/ic_linkedin_white.png";
import { useAuth } from "@/context/AuthContext";

const Footer: React.FC<any> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <>
      <footer className="flex items-center justify-center !p-4 text-white bg-gradient-to-br from-[#72A853] to-[#004c13] w-full">
        <div
          className="flex justify-around items-start w-full
            max-[769px]:flex-col
            max-[769px]:items-center
            max-[769px]:text-center
            max-[769px]:gap-5
          "
        >
          <div className="flex flex-col items-center gap-2.5">
            <img
              src={logo_branca}
              alt="logo"
              style={{
                width: "230px",
              }}
            />
            <p className="!font-[poppins] text-2xl max-[769px]:!mt-8">
              Siga Nossas Redes Socias
            </p>
            <ul className="flex justify-between">
              <a
                href="https://www.linkedin.com/company/ecolifemeioambiente/"
                target="_blank"
              >
                <li>
                  <img src={ic_linkedin_white} />
                </li>
              </a>
              <a
                href="https://www.facebook.com/lifetecnologiaeconsultoria"
                target="_blank"
              >
                <li className="pl-8 pr-8">
                  <img src={ic_face_white} />
                </li>
              </a>
              <a
                href="https://www.instagram.com/ecolifemeioambiente/"
                target="_blank"
              >
                <li>
                  <img src={ic_insta_white} />
                </li>
              </a>
            </ul>
          </div>
          {user !== null && (
            <div className="max-w-md">
              <div>
                <ul className="list-none float-left mr-[50px] leading-[75px] max-[769px]:hidden">
                  <li className="cursor-pointer">
                    <span
                      className="text-lg font-medium"
                      onClick={() => navigate("/homeBuy")}
                    >
                      {t("home")}
                    </span>
                  </li>
                  <li className="cursor-pointer">
                    <span
                      className="text-lg font-medium"
                      onClick={() => navigate("/pronouncement")}
                    >
                      {t("Pronouncements")}
                    </span>
                  </li>
                  <li className="cursor-pointer">
                    <span
                      className="text-lg font-medium"
                      onClick={() => navigate("/mySpace")}
                    >
                      {t("my-space")}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          )}
          <div className="max-w-md">
            <div>
              <ul className="list-none float-left mr-[50px] leading-[75px] max-[769px]:hidden">
                {user === null && (
                  <li className="cursor-pointer">
                    <span
                      className="text-lg font-medium"
                      onClick={() => navigate("/choice")}
                    >
                      Entrar
                    </span>
                  </li>
                )}
                {user !== null && (
                  <li className="cursor-pointer">
                    <span
                      className="text-lg font-medium"
                      onClick={() => navigate("/news")}
                    >
                      {t("news")}
                    </span>
                  </li>
                )}
                <li className="cursor-pointer">
                  <span
                    className="text-lg font-medium"
                    onClick={() => navigate("/contact")}
                  >
                    {t("contact")}
                  </span>
                </li>
                <li className="cursor-pointer">
                  <span
                    className="text-lg font-medium"
                    onClick={() => {
                      window.open("https://iniciativaverde.org.br/calculadora");
                    }}
                  >
                    {t("calculate-co2")}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="max-w-md leading-[30px] max-[769px]:hidden flex flex-col gap-8 mt-5.5">
            <h1 className="!font-[poppins] text-white !font-medium !mb-2.5 !text-2xl">
              {t("contact-us")}
            </h1>
            <p className="!font-[poppins] !text-sm !text-white leading-[35px] max-[769px]:text-start">
              <img className="w-[30px] float-left mr-4" src={ic_telephone} />
              <a
                style={{ fontSize: "18px" }}
                href="tel:+556135472977"
                target="_blank"
                rel="noreferrer"
              >
                (61) 3547-2977
              </a>
            </p>
            <p className="!font-[poppins] !text-sm !text-white leading-[35px]">
              <img className="w-[30px] float-left mr-4" src={ic_mail} />
              <a
                href="mailto:comercial@ecolifemeioambiente.com.br"
                target="_blank"
                rel="noreferrer"
                style={{ fontSize: "18px" }}
              >
                comercial@ecolifemeioambiente.com.br
              </a>
            </p>
          </div>
        </div>
      </footer>
      <div className="flex justify-around items-center w-full">
        <div className="flex flex-col items-center">
          <img src={logo_login} width={100} />
          <p className="text-[#50700F] italic !text-[10px]">Mercado de Crédito de Carbono</p>
        </div>
        <p className="text-[#50700F] italic max-[769px]:hidden">
          Copyright © 2024 ECOLIFE – Tecnologia e Meio Ambiente.&nbsp;
          {t("developed-by")}: Ecolife
        </p>

        <div className="flex items-center">
          <img src={ic_whats} width={24} />
          <h2 className="!text-xl !text-[#356405] !font-bold pl-4">
            +55 61 98100-0130
          </h2>
        </div>
      </div>
    </>
  );
};

export default Footer;
